import React from 'react';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../../../../../cra/src/styling/breakpointsMinWidth';

const HeaderWrap = styled.header`
  margin: 28px;

  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 12px;

  @media ${breakpointsMinWidth.tabletSm} {
    margin: 28px 0;

    grid-template-columns: repeat(8, 1fr);
    grid-column-gap: 24px;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-template-columns: repeat(12, 1fr);
  }
`;

const Heading = styled.h2`
  color: #333d47;

  margin: 0;

  grid-column: 1/-1;

  @media ${breakpointsMinWidth.tabletSm} {
    grid-column: 2/-2;
  }

  @media ${breakpointsMinWidth.desktopLg} {
    grid-column: 3/-3;
  }
`;

const Paragraph = styled.p`
  margin: 0;

  grid-column: 1/-1;

  font-size: 16px;
  line-height: 28px;

  @media ${breakpointsMinWidth.tabletSm} {
    grid-column: 2/-2;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-column: 2/-4;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    grid-column: 2/-6;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    grid-column: 2/-7;
  }

  @media ${breakpointsMinWidth.desktopLg} {
    grid-column: 3/-8;
  }
`;

const Header = () => (
  <HeaderWrap>
    <Heading>Blogs</Heading>
    <Paragraph>
      Welcome to our blog! We work with experts around the world to gather some
      of the best ideas in job search, resume writing, and other forms of career
      profiles. By reading these articles, you will learn to write a
      professional resume or a cover letter in minutes. Stay tuned for more
      articles every month!
    </Paragraph>
  </HeaderWrap>
);

export default Header;
